export default "__VITE_ASSET__ee05ea78__"